import React, { useContext } from "react";

import { createBrowserRouter } from 'react-router-dom';
import Home from './Pages/Home';
import MainLayout from './Components/Layout/MainLayout';
import ErrorPage from './Pages/ErrorPage/ErrorPage';
import Accordion from "./Pages/Accordion";
import VideoPlayer from "./Components/VideoPlayer/VideoPlayer";
import Courses from "./Pages/Student/Courses/Courses";
import CourseContent from "./Pages/Student/Courses/CourseContent";
import Lessson from "./Pages/Student/Courses/Lesson/Lesson";
import Users from "./Pages/Users/Users";
import { useRole } from "./hooks/useRole";
import cookies from 'js-cookie';
import jwt_decode from "jwt-decode";
import UserContent from "./Pages/Users/UserContent";
import LeadContent from "./Pages/Leads/leadContent";
import AssingCourse from "./Pages/Users/AssignCourse";
import Leads from "./Pages/Leads/Leads";
interface IRoute {
    title: string;
    path: string;
    ishidden: boolean;
    component: any;
    icon: string;
    perms: string[],
    children: IRoute[]

};
let decoded: any ="";
let Role: any ="";
let token :any= cookies.get("jwt")
if(token) {

     decoded = jwt_decode(token) 
     Role = decoded.data.user.role_id == 1 ? "admin" : decoded.data.user.role_id == 2 ? "student" : "moderator";
}


export const routes: IRoute[] = [
   
    {
        title: "My Courses",
        path :"/courses", 
        ishidden : false,
        component :  <Courses/>, 
        children: [] ,
        icon: "bi bi-grid" ,
        perms:[Role]
    },
    {
        title: "My Courses",
        path :"/", 
        ishidden : true,
        component :  <Courses/>, 
        children: [] ,
        icon: "bi bi-grid" ,
        perms:Role
    },
      
    {
        title: "Configuration",
        path :"",
        icon :"bi bi-menu-button-wide",
        perms:["admin","moderator"],
        ishidden:false,
        component :"",
        children: [
            
    
            
            {
                title: 'Users',
                path: '/users',
                ishidden: false,
                component: <Users />,
                icon: 'bi bi-circle',
                perms: ['admin'],
                 children :[]
            },
            {
                title: 'Leads',
                path: '/leads',
                ishidden: false,
                component: <Leads />,
                icon: 'bi bi-circle',
                perms: ['admin'],
                 children :[]
            },
            {
                title: 'Leads',
                path: '/leads',
                ishidden: false,
                component: <Leads />,
                icon: 'bi bi-circle',
                perms: ['moderator'],
                 children :[]
            },
            {
                title: '',
                path: 'course',
                ishidden: true,
                component: <CourseContent />,
                icon: 'bi bi-circle',
                perms: ['admin'],
                 children :[]
            },
            {
                title: '',
                path: 'usercontent',
                ishidden: true,
                component: <UserContent />,
                icon: 'bi bi-circle',
                perms: ['admin'],
                 children :[]
            },
            {
                title: '',
                path: 'leadContent',
                ishidden: true,
                component: <LeadContent />,
                icon: 'bi bi-circle',
                perms: ['admin'],
                 children :[]
            },
        
            {
                title: '',
                path: 'assgingcourse',
                ishidden: true,
                component: <AssingCourse />,
                icon: 'bi bi-circle',
                perms: ['admin'],
                 children :[]
            },
            {
                title: '',
                path: 'lesson',
                ishidden: true,
                component: <Lessson />,
                icon: 'bi bi-circle',
                perms: ['test'],
                 children :[]
            },
            {
                title: "My Courses",
                path :"/", 
                ishidden :true,
                component : <Courses/>, 
                children: [] ,
                icon: "bi bi-grid" ,
                perms:["student"]
            },
        ]
    }
]

interface IElement {
    path: string;
    element: any
}
const elements = [];

for (let index = 0; index < routes.length; index++) {
    
   elements.push({ path: routes[index].path ,element : routes[index].component})
   let children = routes[index].children ;
   for (let childIndex = 0; childIndex < children.length; childIndex++) {
    elements.push({ path: children[childIndex].path ,element : children[childIndex].component})
    
   }
    
}



const router = createBrowserRouter([
    {
        path: "/", element: <MainLayout />,
        errorElement: <ErrorPage />,
        children: elements
    }
])


export default router